module.exports = __webpack_public_path__ + "static/media/a-smarter-harvest-desktop.37e12301.jpg";